import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-caption ml-2"
}
const _hoisted_2 = {
  key: 1,
  class: "text-caption text-medium-emphasis mr-2"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_5 = {
  key: 2,
  class: "text-overline"
}
const _hoisted_6 = { class: "text-h6" }
const _hoisted_7 = {
  key: 0,
  class: "text-center pa-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmbeddingModelSummaryCard = _resolveComponent("EmbeddingModelSummaryCard")!
  const _component_EmbeddingModelCard = _resolveComponent("EmbeddingModelCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ConfigCardOverlay = _resolveComponent("ConfigCardOverlay")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_FormattingCard = _resolveComponent("FormattingCard")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_treeview = _resolveComponent("v-treeview")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "my-0 ml-0 mr-n2 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("p", null, " Add local files to be used for embedding / RAG operations. Please note that you must use the same embedding model, and that API must be defined and accessible, when using the embeddings you create here. ", -1),
              _createElementVNode("p", null, "Steps:", -1),
              _createElementVNode("ol", { class: "ml-6" }, [
                _createElementVNode("li", { class: "pl-2" }, "Add embedding model (if none exist)"),
                _createElementVNode("li", { class: "pl-2" }, "Set a name for your embedding collection"),
                _createElementVNode("li", { class: "pl-2" }, "Select embedding model next to collection name"),
                _createElementVNode("li", { class: "pl-2" }, "Choose files to create embeddings for"),
                _createElementVNode("li", { class: "pl-2" }, "Click \"Embed\" (do not refresh the page until completed)")
              ], -1)
            ])),
            _: 1,
            __: [14]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "mx-0 mt-2 mb-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "ma-0 pa-2 d-flex align-center"
          }, {
            default: _withCtx(() => [
              (_ctx.savedEmbeddingModels.length > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    buttonClass: "ml-1",
                    icon: "mdi-plus",
                    click: _ctx.openCreateModelOverlay,
                    size: "x-large",
                    tooltip: "New Embedding Model",
                    variant: "outlined",
                    density: "default",
                    color: "secondary"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedEmbeddingModels, (model) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: model.config.id,
              cols: _ctx.isDesktop ? 4 : 12,
              class: "ma-0 pa-2"
            }, {
              default: _withCtx(() => [
                (_ctx.isDesktop)
                  ? (_openBlock(), _createBlock(_component_EmbeddingModelSummaryCard, {
                      key: 0,
                      model: model,
                      onEdit: _ctx.openEditModelOverlay
                    }, null, 8, ["model", "onEdit"]))
                  : (_openBlock(), _createBlock(_component_EmbeddingModelCard, {
                      key: 1,
                      modelId: model.config.id,
                      onModelDeleted: _ctx.handleModelDeleted,
                      onRemoveCard: _ctx.removeModelCard,
                      onSaved: _ctx.handleModelSaved
                    }, null, 8, ["modelId", "onModelDeleted", "onRemoveCard", "onSaved"]))
              ]),
              _: 2
            }, 1032, ["cols"]))
          }), 128)),
          (_ctx.savedEmbeddingModels.length === 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: _ctx.isDesktop ? 4 : 12,
                class: "ma-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    onClick: _ctx.openCreateModelOverlay,
                    class: "ma-0 pa-2 card add-card",
                    color: "surface",
                    density: "compact",
                    variant: "elevated",
                    elevation: "4"
                  }, {
                    default: _withCtx(() => [
                      _cache[15] || (_cache[15] = _createElementVNode("p", null, "New Embedding Model", -1)),
                      _createVNode(_component_v_icon, {
                        class: "add-icon",
                        icon: "mdi-plus"
                      })
                    ]),
                    _: 1,
                    __: [15]
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["cols"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showCreateModelOverlay,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showCreateModelOverlay) = $event)),
        title: "New Embedding Model",
        onClose: _ctx.closeCreateModelOverlay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_EmbeddingModelCard, {
            isOverlay: "",
            onRemoveCard: _ctx.closeCreateModelOverlay,
            onModelDeleted: _ctx.handleModelDeleted,
            onSaved: _ctx.handleModelSaved
          }, null, 8, ["onRemoveCard", "onModelDeleted", "onSaved"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showEditModelOverlay,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showEditModelOverlay) = $event)),
        title: "Edit Embedding Model",
        onClose: _ctx.closeEditModelOverlay
      }, {
        default: _withCtx(() => [
          (_ctx.editingModelId)
            ? (_openBlock(), _createBlock(_component_EmbeddingModelCard, {
                key: 0,
                modelId: _ctx.editingModelId,
                isOverlay: "",
                startExpanded: "",
                onRemoveCard: _ctx.closeEditModelOverlay,
                onModelDeleted: _ctx.handleEditedModelDeleted,
                onSaved: _ctx.handleModelSaved
              }, null, 8, ["modelId", "onRemoveCard", "onModelDeleted", "onSaved"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "mx-0 mt-4 mb-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "4",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_combobox, {
                modelValue: _ctx.collection,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collection) = $event)),
                  _ctx.targetCollectionUpdated
                ],
                items: _ctx.collectionNames,
                "return-object": "",
                "item-title": "name",
                density: "compact",
                label: "New or Existing Collection Name",
                "hide-details": "",
                "onUpdate:search": _ctx.handleCollectionInput,
                variant: "outlined"
              }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "onUpdate:search"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "4",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedTarget,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTarget) = $event)),
                items: _ctx.savedEmbeddingModels,
                "item-title": "config.name",
                "item-value": "config",
                "return-object": true,
                label: "Embedding Model",
                rules: [() => !!_ctx.selectedTarget || 'Embedding Model is required.'],
                density: "compact",
                variant: "outlined",
                "hide-details": ""
              }, null, 8, ["modelValue", "items", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_number_input, {
                reverse: false,
                controlVariant: "stacked",
                label: "Chunk Size",
                hideInput: false,
                inset: false,
                step: 8,
                min: 32,
                max: 2048,
                modelValue: _ctx.chunkSize,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chunkSize) = $event)),
                density: "compact",
                variant: "outlined"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_number_input, {
                reverse: false,
                controlVariant: "stacked",
                label: "Chunk Overlap",
                hideInput: false,
                inset: false,
                step: 4,
                min: 0,
                max: 128,
                modelValue: _ctx.chunkOverlap,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.chunkOverlap) = $event)),
                density: "compact",
                variant: "outlined"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "auto",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: _ctx.directoryMode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.directoryMode) = $event)),
                density: "compact",
                inset: "",
                color: _ctx.directoryMode ? 'primary' : '',
                "hide-details": "",
                class: "mt-2"
              }, {
                prepend: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("span", null, "Upload entire directory (preserves folder structure)", -1)
                ])),
                _: 1
              }, 8, ["modelValue", "color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "11",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_file_input, {
                modelValue: _ctx.fileInputModel,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fileInputModel) = $event)),
                label: _ctx.directoryMode ? 'Select directory to embed...' : 'Select files to embed...',
                multiple: "",
                counter: "",
                clearable: "",
                density: "compact",
                loading: _ctx.readingFiles,
                ref: "fileSelect",
                "hide-details": "",
                variant: "outlined",
                webkitdirectory: _ctx.directoryMode,
                directory: _ctx.directoryMode,
                class: "file-input-constrained-height mb-2 pt-1"
              }, null, 8, ["modelValue", "label", "loading", "webkitdirectory", "directory"]),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ml-11 text-caption" }, [
                _createTextVNode(" Supports text based files like markdown and code (.md, .txt, .js, .py, .ts, .html, etc.), Office formats (.docx, .xlsx, .pptx) and PDFs."),
                _createElementVNode("br")
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "ml-11 text-caption" }, "Results can vary based on document quality.", -1))
            ]),
            _: 1,
            __: [17,18]
          }),
          _createVNode(_component_v_col, {
            cols: "1",
            class: "ma-0 pa-2 mt-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                onClick: _ctx.embedFiles,
                disabled: _ctx.embedDisabled,
                loading: _ctx.embeddingActive
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("Embed")
                ])),
                _: 1,
                __: [19]
              }, 8, ["onClick", "disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.embeddingActive)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "ma-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    variant: "outlined",
                    class: "pa-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h6 pa-0 mb-2" }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode(" Embedding Progress ")
                        ])),
                        _: 1,
                        __: [20]
                      }),
                      _createVNode(_component_v_card_subtitle, { class: "pa-0 mb-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Processing " + _toDisplayString(_ctx.successfulEmbeds) + " of " + _toDisplayString(_ctx.totalFilesToEmbed) + " files... ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pa-0 mb-3 text-caption" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Status: " + _toDisplayString(_ctx.processingStatusText), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        align: "center",
                        class: "ma-0 pa-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "ma-0 pa-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_progress_linear, {
                                "model-value": _ctx.embedProgress,
                                color: "primary",
                                height: "25",
                                striped: ""
                              }, {
                                default: _withCtx(({ value }) => [
                                  _createElementVNode("strong", null, _toDisplayString(Math.ceil(value)) + "%", 1)
                                ]),
                                _: 1
                              }, 8, ["model-value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "auto",
                            class: "ma-0 pa-0 pl-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                color: "warning",
                                onClick: _ctx.cancelEmbedding,
                                icon: "mdi-cancel"
                              }, null, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.failedFiles.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "warning",
                            density: "compact",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Failed to embed " + _toDisplayString(_ctx.failedFiles.length) + " file(s): " + _toDisplayString(_ctx.failedFiles.join(', ')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                variant: "outlined",
                class: "pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expand_transition, null, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_v_container, {
                        class: "ma-0 pa-0 embedding-search-results",
                        fluid: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            density: "compact",
                            class: "ma-0 pa-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "9",
                                class: "ma-0 pa-2 flex flex-column"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_textarea, {
                                    modelValue: _ctx.searchText,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchText) = $event)),
                                    rows: "9",
                                    class: "flex-grow-1",
                                    "no-resize": "",
                                    "auto-grow": "",
                                    label: "Search",
                                    density: "compact",
                                    variant: "outlined"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "ma-0 pa-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.searchTarget,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchTarget) = $event)),
                                    items: _ctx.savedEmbeddingModels,
                                    "item-title": "config.name",
                                    "return-object": true,
                                    label: "Embedding Model",
                                    rules: [() => !!_ctx.searchTarget || 'Embedding Model is required.'],
                                    density: "compact",
                                    variant: "outlined",
                                    class: "display-block mb-2"
                                  }, null, 8, ["modelValue", "items", "rules"]),
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.searchCollection,
                                    "onUpdate:modelValue": [
                                      _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchCollection) = $event)),
                                      _ctx.searchCollectionUpdated
                                    ],
                                    items: _ctx.localCollections,
                                    "item-title": "name",
                                    "return-object": true,
                                    label: "Local Collection",
                                    rules: [() => !!_ctx.searchCollection || 'Collection is required.'],
                                    density: "compact",
                                    variant: "outlined",
                                    class: "display-block mb-2"
                                  }, null, 8, ["modelValue", "items", "rules", "onUpdate:modelValue"]),
                                  _createVNode(_component_v_number_input, {
                                    modelValue: _ctx.searchTopK,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchTopK) = $event)),
                                    label: "Results (k)",
                                    min: 1,
                                    max: 100,
                                    step: 1,
                                    density: "compact",
                                    variant: "outlined",
                                    class: "display-block mb-2"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_Button, {
                                    color: "primary",
                                    click: _ctx.search,
                                    icon: "mdi-send-outline",
                                    size: "x-large",
                                    tooltip: "Search"
                                  }, null, 8, ["click"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (r, index) => {
                            return (_openBlock(), _createBlock(_component_v_row, {
                              key: r.id || index,
                              class: "ma-0 pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "ma-0 pa-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      class: "mb-0",
                                      density: "compact",
                                      variant: "outlined"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_FormattingCard, {
                                          title: `${index+1}. ${_ctx.decodeBase64(r.fileName ?? '')}`,
                                          content: r.text,
                                          lineStart: r.lines?.start,
                                          lineEnd: r.lines?.end
                                        }, null, 8, ["title", "content", "lineStart", "lineEnd"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.show]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { density: "compact" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode("Collection Search")
                        ])),
                        _: 1,
                        __: [21]
                      }, 512), [
                        [_vShow, !_ctx.show]
                      ]),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        size: "x-large",
                        class: "mx-auto",
                        icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toggleSearch(!_ctx.show))),
                        density: "compact"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center pa-3" }, {
                    default: _withCtx(() => [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-h6" }, "Embedding Collections", -1)),
                      (_ctx.list.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.totalStorage) + " total)", 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer),
                      (_ctx.isLoadingCollections && !_ctx.manualRefresh)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Loading... "))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "text",
                        size: "small",
                        onClick: _ctx.refreshCollections,
                        loading: _ctx.isLoadingCollections,
                        disabled: _ctx.isLoadingCollections,
                        class: "ml-2 mr-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("mdi-refresh")
                            ])),
                            _: 1,
                            __: [22]
                          }),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "bottom"
                          }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode("Refresh Collections")
                            ])),
                            _: 1,
                            __: [23]
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading", "disabled"])
                    ]),
                    _: 1,
                    __: [24]
                  }),
                  _createVNode(_component_v_divider),
                  (_openBlock(), _createBlock(_component_v_treeview, {
                    items: _ctx.listTree,
                    key: _ctx.collectionsKey,
                    opened: _ctx.openedItems,
                    "onUpdate:opened": _ctx.handleTreeOpened,
                    "item-value": "id"
                  }, {
                    title: _withCtx(({ item }) => [
                      (item.itemType === 'file')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.handleFileClick(item)),
                            class: "file-link"
                          }, _toDisplayString(item.title), 9, _hoisted_3))
                        : _createCommentVNode("", true),
                      (item.itemType === 'collection')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.title), 1))
                        : _createCommentVNode("", true),
                      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                      (item.itemType === 'collection')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.subtitle), 1))
                        : _createCommentVNode("", true)
                    ]),
                    append: _withCtx(({ item }) => [
                      (item.itemType === 'collection')
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            color: "warning",
                            class: "mr-4",
                            icon: "mdi-trash-can-outline",
                            size: "large",
                            tooltip: "Delete collection",
                            density: "compact",
                            click: (e) => { _ctx.deleteCollection(e, item) }
                          }, null, 8, ["click"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["items", "opened", "onUpdate:opened"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showFileDialog,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showFileDialog) = $event)),
        "max-width": "900px",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.fileDialogTitle), 1),
                  _createVNode(_component_v_spacer),
                  (_ctx.selectedFile != null)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "mdi-download-outline",
                        size: "large",
                        width: "32",
                        tooltip: "Download File",
                        click: () => _ctx.downloadFile(_ctx.selectedFile!.id, _ctx.selectedFile!.filename)
                      }, null, 8, ["click"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, {
                    icon: "mdi-close",
                    size: "large",
                    width: "32",
                    tooltip: "Close",
                    click: _ctx.closeFileDialog
                  }, null, 8, ["click"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, { class: "pa-0" }, {
                default: _withCtx(() => [
                  (_ctx.loadingFileContent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary"
                        }),
                        _cache[26] || (_cache[26] = _createElementVNode("p", { class: "mt-4" }, "Loading file content...", -1))
                      ]))
                    : (_openBlock(), _createBlock(_component_FormattingCard, {
                        key: 1,
                        content: _ctx.fileContent,
                        expanded: 'true'
                      }, null, 8, ["content"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}